import { FacebookIcon, LinkedInIcon, TwitterIcon, RedditIcon } from 'ui';

interface FooterSection {
    name: string;
    links: {
        label: string;
        href: string;
        target?: string;
        icon?: JSX.Element;
    }[];
}

export const footerSections: FooterSection[] = [
    {
        name: 'Get started',
        links: [
            { label: 'Home', href: '/' },
            { label: 'Pricing', href: '/pricing' },
            { label: 'Contact', href: '/contact' }
        ]
    },
    {
        name: 'Resources',
        links: [
            { label: 'Blog', href: '/resources?type=blog' },
            { label: 'Help hub', href: '/resources?type=help-hub' },
            { label: 'Video tutorials', href: 'resources?type=video-instructions' }
        ]
    },
    {
        name: 'Social',
        links: [
            { label: 'X / Twitter', href: 'https://twitter.com/ElumityApp', target: '_blank', icon: <TwitterIcon /> },
            {
                label: 'Facebook',
                href: 'https://www.facebook.com/profile.php?id=61561205641337',
                target: '_blank',
                icon: <FacebookIcon />
            },
            { label: 'Reddit', href: 'https://reddit.com/r/elumity', target: '_blank', icon: <RedditIcon /> },
            {
                label: 'LinkedIn',
                href: 'https://ba.linkedin.com/company/elumity?trk=ppro_cprof',
                target: '_blank',
                icon: <LinkedInIcon />
            }
        ]
    },
    {
        name: 'Company',
        links: [
            { label: 'About us', href: '/about-us' },
            { label: 'Terms & Conditions', href: '/terms-and-conditions' },
            { label: 'Privacy Policy', href: '/privacy-policy' },
            { label: 'Copyright', href: '/copyright' }
        ]
    }
];
